import { useEffect, useState } from "react";

export default function OfferPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem("offerSeen");

    if (!seen) {
      setTimeout(() => {
        setShow(true);
      }, 1000);
    }
  }, []);

  const closePopup = () => {
    localStorage.setItem("offerSeen", "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm flex items-center justify-center px-4">

      <div className="relative bg-white rounded-3xl overflow-hidden max-w-md w-full shadow-2xl">

        {/* Close */}
        <button
          onClick={closePopup}
          className="absolute top-3 right-4 z-10 text-white text-3xl font-bold"
        >
          ×
        </button>

        {/* Offer Image */}
        <img
          src="/offerImage.jpeg"
          alt="Moffee Magic Offer"
          className="w-full"
        />

        {/* CTA */}
        <div className="p-5 text-center">
          <a
            href="#products"
            onClick={closePopup}
            className="inline-block bg-[#d68c45] hover:bg-[#c57a3a] text-white font-semibold px-8 py-3 rounded-xl transition"
          >
            Grab The Offer
          </a>
        </div>

      </div>

    </div>
  );
}